import { useSearchParams } from "react-router-dom";
import CharityIssueCategoryService from "../../../services/CharityIssueCategoryService";
import { useEffect, useState } from "react";
import { CharityIssueCategory } from "../../../models";
import Breadcrumbs from "../../../components/breadcrumbs";
 
import CharityIssueCategoriesTable from "./ui/charity-issue-categories-table";
import CharityIssueCategoriesTableSkeleton from "./skeletons/charity-issue-categories-table-skeleton";
import toast from "react-hot-toast";
import { CreateButton } from "./ui/buttons";

export default function CharityIssueCategoriesPage(){
    const [searchParams] = useSearchParams();
      const api = new CharityIssueCategoryService();
      const [items, setItems] = useState<CharityIssueCategory[]>([]);
      const [loading, setLoading] = useState(true);
    
      useEffect(() => {
        fetchData();
      }, [searchParams.get("reload")]);
    
      const fetchData = async () => {
        try{
        const data = await api.getCharityIssueCategories();
        setItems(data);
    }
    catch(e){
        console.log(e);
        toast.error("Data load error");
    }
    setLoading(false);
      };
    
      return (
        <div className="w-full">
             <Breadcrumbs
                        breadcrumbs={[
                          { label: "Charity Issue Categories", href: "/admin/charity-issue-categories" },                      
                        ]}
                      />
          
          <CreateButton />
          {loading ? (
            <CharityIssueCategoriesTableSkeleton />
          ) : (
            <CharityIssueCategoriesTable categories={items} />
          )}
        </div>
      );
    }
